import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { arabicError } from "../lib/api";
import { LogIn } from "lucide-react";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("تم تسجيل الدخول بنجاح");
      navigate(user.role === "admin" ? "/admin" : user.role === "employee" ? "/reservations" : "/dashboard");
    } catch (err) {
      toast.error(arabicError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-stretch bg-[#EBF4F6]" dir="rtl">
      {/* Image side */}
      <div className="hidden lg:block w-1/2 relative">
        <img
          src="https://images.pexels.com/photos/32021732/pexels-photo-32021732.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1024&w=1024"
          alt="tiles"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-[#09637E]/85 to-[#09637E]/40" />
        <div className="absolute inset-0 flex flex-col justify-end p-12 text-white">
          <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center text-3xl font-extrabold mb-6">إ</div>
          <h1 className="text-5xl font-extrabold leading-tight mb-4">منصة إمداد</h1>
          <p className="text-xl opacity-90 leading-relaxed max-w-lg">
            اربط تجار السيراميك في سوريا عبر بحث ذكي بالصور واحجز ما تحتاجه من مخزون زملائك التجار.
          </p>
        </div>
      </div>

      {/* Form side */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden text-center mb-8">
            <div className="w-14 h-14 rounded-xl bg-[#09637E] text-white font-extrabold text-2xl flex items-center justify-center mx-auto mb-3">إ</div>
            <h1 className="text-3xl font-extrabold text-[#09637E]">إمداد</h1>
          </div>

          <div className="bg-white border border-[#7AB2B2] rounded-2xl p-8 shadow-sm">
            <h2 className="text-3xl font-extrabold text-[#333333] mb-2">تسجيل الدخول</h2>
            <p className="text-[#666666] mb-6">أدخل بيانات حسابك للمتابعة</p>

            <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
              <div>
                <label className="block text-sm font-bold text-[#333333] mb-2">البريد الإلكتروني</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="login-email-input"
                  className="h-12 w-full rounded-lg border border-[#7AB2B2] bg-white px-4 text-[#333333] focus:outline-none focus:ring-2 focus:ring-[#09637E]"
                  placeholder="example@imdad.com"
                />
              </div>
              <div>
                <label className="block text-sm font-bold text-[#333333] mb-2">كلمة المرور</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="login-password-input"
                  className="h-12 w-full rounded-lg border border-[#7AB2B2] bg-white px-4 text-[#333333] focus:outline-none focus:ring-2 focus:ring-[#09637E]"
                  placeholder="••••••••"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="login-submit-btn"
                className="h-12 w-full rounded-lg bg-[#09637E] hover:bg-[#088395] text-white font-extrabold flex items-center justify-center gap-2 transition-colors disabled:opacity-60"
              >
                <LogIn size={18} />
                {loading ? "جارٍ الدخول..." : "دخول"}
              </button>
            </form>

            <div className="mt-6 text-center text-[#666666]">
              ليس لديك حساب؟{" "}
              <Link to="/register" data-testid="go-to-register" className="inline-flex items-center min-h-[44px] px-2 text-[#09637E] font-bold hover:underline">
                سجل كتاجر
              </Link>
              <div className="mt-1 text-sm">
                <Link to="/forgot-password" data-testid="forgot-link" className="inline-flex items-center min-h-[44px] px-2 text-[#088395] hover:underline">نسيت كلمة المرور؟</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
